export enum Product {
  Algo = 1,
  Gallery = 2,
  Opportunity = 3,
  Wallet = 4,
}
